module.exports = __webpack_public_path__ + "img/delivery_2.e87ff0e4.png";